import { render, staticRenderFns } from "./UploadTaxDocument.vue?vue&type=template&id=0816d755&scoped=true"
import script from "./UploadTaxDocument.vue?vue&type=script&lang=js"
export * from "./UploadTaxDocument.vue?vue&type=script&lang=js"
import style0 from "./UploadTaxDocument.vue?vue&type=style&index=0&id=0816d755&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816d755",
  null
  
)

export default component.exports